module.exports = __webpack_public_path__ + "img/advantage1_1@2x.a955137d.png";